import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

interface CapacityData {
  balance: number;
  unit?: string;
}

export default function Capacity() {
  const [capacity, setCapacity] = useState<CapacityData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [amount, setAmount] = useState('');
  const [toppingUp, setToppingUp] = useState(false);

  useEffect(() => {
    loadCapacity();
  }, []);

  async function loadCapacity() {
    try {
      setLoading(true);
      setError('');
      const res = await api.get('/api/capacity');
      setCapacity(res.data || res);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleTopUp(e: React.FormEvent) {
    e.preventDefault();
    try {
      setToppingUp(true);
      setError('');
      await api.post('/api/capacity/topup', { amount: parseFloat(amount) });
      setAmount('');
      loadCapacity();
    } catch (err: any) {
      setError(err.message);
    } finally {
      setToppingUp(false);
    }
  }

  return (
    <div>
      <h1 style={styles.heading}>Capacity</h1>
      {error && <div style={styles.error}>{error}</div>}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div style={styles.statsGrid}>
            <div style={styles.statCard}>
              <div style={styles.statLabel}>Balance</div>
              <div style={styles.statValue}>
                {capacity?.balance ?? 0} {capacity?.unit ?? 'units'}
              </div>
            </div>
          </div>

          <h2 style={styles.subheading}>Top Up</h2>
          <form onSubmit={handleTopUp} style={styles.form}>
            <input
              placeholder="Amount"
              type="number"
              step="1"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              style={styles.input}
              required
            />
            <button type="submit" disabled={toppingUp} style={styles.button}>
              {toppingUp ? 'Processing...' : 'Top Up'}
            </button>
          </form>
        </>
      )}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  heading: { fontSize: 20, fontWeight: 600, marginBottom: 16 },
  error: { background: '#fef2f2', color: '#991b1b', padding: 10, borderRadius: 8, marginBottom: 12 },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 32 },
  statCard: { background: '#fff', padding: 20, borderRadius: 8, border: '1px solid #e5e7eb' },
  statLabel: { fontSize: 12, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.5 },
  statValue: { fontSize: 28, fontWeight: 600, marginTop: 8 },
  subheading: { fontSize: 16, fontWeight: 600, marginBottom: 12 },
  form: { display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' },
  input: { padding: '8px 10px', fontSize: 14, border: '1px solid #e5e7eb', borderRadius: 6, minWidth: 140 },
  button: { padding: '8px 16px', fontSize: 14, background: '#111827', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' },
};
